import { getTokenInfo } from "../services/api"
import { getOrgEmployees } from "../services/globalData";
import { toDirectoryShape } from "../services/directoryShape";

/**
 * The signed-in person as the *directory* knows them: name, photograph,
 * department, reporting line. Enough to sign a policy or greet somebody.
 *
 * Narrowed on purpose. This reads the org directory, which answers with ten
 * fields for an employee and forty-three for an admin, so anything richer that
 * happens to work while you are testing as an admin will be undefined for most
 * of the company. Two bugs shipped exactly that way — an onboarding gate that
 * never fired and a profile wizard that never prefilled.
 *
 * For your own record in full — onboarding state, joining date, bank details —
 * use useSelfEmployee(), which fetches it.
 */
export const currentUserDetails = () => {
    const empId = getTokenInfo()?.accessTokenData?.employeeId;
    const userDetails = getOrgEmployees()?.filter(emp=>emp._id===empId)||[];
    return toDirectoryShape(userDetails[0]);
}
